import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { fetchCustomContent } from '../store/actions/customContents';

export const useCustomContent = type => {
  const dispatch = useDispatch();
  const customContent = useSelector(state => state.customContents[type]);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!customContent && !hasFetched.current) {
      hasFetched.current = true;
      dispatch(fetchCustomContent(type));
    }
  }, [dispatch, type]);

  return customContent ? customContent : {};
};
